import styled from "styled-components";
import { Card } from "./Card";
import colors from "@styling/colors";
import { spacing } from "@styling/sizing";
import { fontSizes } from "@styling/fonts";

const EmptyStateContainer = styled(Card)`
  padding: ${spacing.x4}px;
  text-align: center;
  color: ${colors.textMuted};
`;

const EmptyStateMessage = styled.div`
  font-size: ${fontSizes.regular}px;
`;

type EmptyStateProps = {
  message?: string;
};

export const EmptyState = ({ message = "No items found." }: EmptyStateProps) => {
  return (
    <EmptyStateContainer>
      <EmptyStateMessage>{message}</EmptyStateMessage>
    </EmptyStateContainer>
  );
};

